import { render } from "./TressGrid.vue?vue&type=template&id=3f7c5141"
const script = {}

import "./TressGrid.vue?vue&type=style&index=0&id=3f7c5141&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__